<template>
    <aside class="sidebar d-print-none" :class="{toggled: sidebarOpen}" v-if="!loading">
        <div class="scrollbar-inner" v-bar="scrollbarOptions">
            <div>
                <SidebarProfile :user="currentUser" />

                <component :user="currentUser" :is="sidebar"></component>
            </div>
        </div>
    </aside>
</template>

<script>
import currentUserQuery from '@components/AppSidebar/queryCurrentUser.graphql';
import SidebarProfile from '@components/SidebarProfile';
import AdminSidebar from '@components/Sidebars/Admin';
import AssociationSidebar from '@components/Sidebars/Association';
import ContractorSidebar from '@components/Sidebars/Contractor';
import GenericSidebar from '@components/Sidebars/Generic';
import GrowerSidebar from '@components/Sidebars/Grower';
import ProcessorSidebar from '@components/Sidebars/Processor';

export default {
  name: 'AppSidebar',
  props: ['sidebarOpen'],
  components: {
    SidebarProfile,
    AdminSidebar,
    AssociationSidebar,
    ContractorSidebar,
    GrowerSidebar,
    GenericSidebar,
    ProcessorSidebar,
  },
  apollo: {
    currentUser: {
      query: currentUserQuery,
    },
  },
  data() {
    return {
      loading: 0,
      currentUser: null,
      scrollbarOptions: {
        preventParentScroll: true,
        useScrollbarPseudo: true,
      },
    };
  },
  computed: {
    sidebar() {
      switch (this.currentUser.role.name) {
        case 'grower':
          return GrowerSidebar;
        case 'admin':
          return AdminSidebar;
        case 'developer':
          return AdminSidebar;
        case 'processor':
          return ProcessorSidebar;
        case 'association':
          return AssociationSidebar;
        case 'contractor':
          return ContractorSidebar;
        default:
          return GenericSidebar;
      }
    },
  },
};
</script>
<style>
    .vb > .vb-dragger {
        z-index: 5;
        width: 3px;
        right: 0;
        opacity: 0;
        transition: opacity 0.3s;
    }

    .vb:hover > .vb-dragger,
    .vb.vb-dragging-phantom > .vb-dragger {
        opacity: 0.4;
    }

    .vb > .vb-dragger > .vb-dragger-styler {
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
        -webkit-transform: rotate3d(0, 0, 0, 0);
        transform: rotate3d(0, 0, 0, 0);
        -webkit-transition: background-color 100ms ease-out, margin 100ms ease-out,
        height 100ms ease-out;
        transition: background-color 100ms ease-out, margin 100ms ease-out,
        height 100ms ease-out;
        background-color: #c2c2c2;
        margin: 5px 0 5px 0;
        border-radius: 20px;
        height: calc(100% - 10px);
        display: block;
    }

    .vb.vb-scrolling-phantom > .vb-dragger > .vb-dragger-styler {
        background-color: #919191;
    }

    .vb > .vb-dragger:hover > .vb-dragger-styler {
        background-color: #919191;
        /*margin: 0px;*/
        /*height: 100%;*/
    }

    .vb.vb-dragging > .vb-dragger > .vb-dragger-styler {
        background-color: pink;
        margin: 0px;
        height: 100%;
    }

    .vb.vb-dragging-phantom > .vb-dragger > .vb-dragger-styler {
        background-color: #919191;
    }
</style>
